import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Transaction } from 'types';

import { formatNumber } from 'utils/formats';

import operationTypes from 'constants/operationTypes';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

const CapitalVariationOperationTableFooter: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const isIncrease =
    data.operation?.operationType === operationTypes.CAPITAL_INCREASE ||
    data.operation?.operationType === operationTypes.CONSTITUTION;

  const getTotalShares = (transactions: Transaction[]) =>
    transactions.reduce(
      (total, transaction) =>
        total + (transaction?.shareTo || 0) - (transaction?.shareFrom || 0) + 1,
      0
    );

  const totalShares = getTotalShares(
    (data.operation?.transactions as Transaction[]) || []
  );

  const finalTotalShares = isIncrease ? totalShares : -totalShares;

  return (
    <>
      <tfoot>
        <tr>
          <td className="fw-bold">{t('Total').toUpperCase()}</td>

          <td className="text-right fw-bold">
            {formatNumber(finalTotalShares)}
          </td>

          <td className="tb-col-md" />

          <td className="tb-col-md" />

          <td className="tb-col-md" />

          <td className="tb-col-md" />
        </tr>
      </tfoot>
    </>
  );
};

export default CapitalVariationOperationTableFooter;
